import { drawGauge } from './draw';

export function initGauges() {
    
    let gaugesList = document.getElementsByClassName('gauge');
    for(let i = 0; i<gaugesList.length; i++) {
        drawGauge(gaugesList[i]);
    }

}